import client from "./client";

const getMe = () => client.get("me");

export default { getMe };